import { UserRolesEnum } from 'shared/enums/user-roles-enum'
import { isAuthorizedUser, isCustomer, isDomainOwner } from 'shared/hooks/use-user'
import type { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'
import { isCustomDomain } from 'shared/utils/is-custom-domain'
import { buildDashboardUrl } from 'modules/white-label/utils/dashboard-url'

export const getShowDashboardLink = (user: UnauthorizedUser | UserInterface | undefined): boolean =>
  (isAuthorizedUser(user) &&
    (isDomainOwner(user) || !isCustomDomain()) &&
    (user.roles.includes(UserRolesEnum.Customer) ||
      user.roles.includes(UserRolesEnum.Affiliate))) ||
  false

export const getDashboardLink = (user: UnauthorizedUser | UserInterface | undefined): string => {
  if (!getShowDashboardLink(user)) return ''

  const baseUrl = buildDashboardUrl('/dashboard')

  return isAuthorizedUser(user) && isCustomer(user) ? baseUrl : `${baseUrl}/affiliate-dashboard`
}

export const getDashboardNotificationSettingsLink = (
  user?: UnauthorizedUser | UserInterface,
): string => `${getDashboardLink(user)}/profile/notification-settings`
